import React from 'react';
import classNames from 'classnames';

import Label from 'components/Label';

import './styles.css';

interface RadioButtonProps {
  name: string;
  value: string;
  checked: boolean;
  onChange: (e: any) => void;
  disabled?: boolean;
  className?: string;
}

const RadioButton = ({
  name,
  value,
  checked,
  onChange,
  disabled,
  className
}: RadioButtonProps) => {
  return (
    <div className={classNames('RadioButton', className)}>
      <Label
        className={classNames('RadioFieldInput', 'colab-clickable', {
          checked,
          disabled
        })}>
        <input
          type="radio"
          name={name}
          checked={checked}
          value={value}
          onClick={onChange}
        />
        {checked && <div className="radioButtonCenter" />}
      </Label>
    </div>
  );
};

export default RadioButton;
